/* =====================================================================
   ALB Filter · Horizon Rebuild – Berater-Teaser

   Holt einen Produktberater von seiner Ratgeber-Seite und haengt ihn an
   die Stelle des Teasers. Damit gibt es die (umfangreiche) Konfiguration
   eines Beraters nur EINMAL, statt auf jeder Seite, die ihn anbietet.

   Bevorzugt die Section Rendering API (?sections=<key>) – sie liefert nur
   den Berater statt der ganzen Seite. Schlaegt das fehl (z. B. falsche
   Section-Kennung), wird die Seite komplett geholt und der Berater daraus
   herausgeschnitten. Scheitert auch das, fuehrt derselbe Klick auf die
   Ratgeber-Seite – der Button ist deshalb ein <a>, kein <button>.

   Das <style> der Section wirkt beim Einhaengen mit; <script> nicht –
   die Komponente wird deshalb hier explizit nachgeladen.
   ===================================================================== */
(function () {
  if (customElements.get('alb-berater-teaser')) return;

  // Modulweit: Mehrere Teaser auf einer Seite fordern das Skript nur einmal an.
  var skriptPromise = null;

  function ladeSkript(src) {
    if (customElements.get('alb-produktberater')) return Promise.resolve();
    if (!src) return Promise.reject(new Error('kein Skriptpfad'));
    if (skriptPromise) return skriptPromise;

    skriptPromise = new Promise(function (ok, fehler) {
      var s = document.createElement('script');
      // Als ES-Modul laden: alb-produktberater.js importiert @shopify/events
      // (Importmap steht laengst im head, siehe snippets/scripts.liquid).
      s.type = 'module';
      s.src = src;
      s.onload = function () { ok(); };
      s.onerror = function () { skriptPromise = null; fehler(new Error('Skript')); };
      document.head.appendChild(s);
    });
    return skriptPromise;
  }

  class AlbBeraterTeaser extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      var self = this;

      // Mehrere Startpunkte sind erlaubt: Der Teaser hat einen Button, die
      // Bereichs-Weiche eine Kachel je Einsatzbereich – jede mit eigenem Ziel.
      var knoepfe = this.querySelectorAll('[data-start]');
      if (!knoepfe.length) return;

      for (var i = 0; i < knoepfe.length; i++) {
        (function (knopf) {
          knopf.addEventListener('click', function (ev) {
            // Cmd/Ctrl/Shift-Klick und Mittelklick weiter dem Browser ueberlassen:
            // Wer den Berater bewusst in einem neuen Tab oeffnet, soll das koennen.
            if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
            if (typeof ev.button === 'number' && ev.button !== 0) return;
            ev.preventDefault();
            self._starten(knopf);
          });
        })(knoepfe[i]);
      }

      // „Beratung neu starten" im Ergebnis fuehrt zurueck zu DIESEM Teaser –
      // er ist der Einstieg dieser Seite und pro Seite gestaltet. Ohne das
      // zeigte der Berater seinen eigenen Intro-Screen, der anders aussieht.
      this.addEventListener('alb:berater-neustart', function (ev) {
        ev.preventDefault();
        // Nur der naechstgelegene Einstieg reagiert: Steckt der Berater in einer
        // eingehaengten Weiche, fuehrt "neu starten" zurueck zu deren Kacheln
        // und nicht bis zum Teaser der Seite darueber.
        ev.stopPropagation();
        self._zurueckZumTeaser();
      });

      // „Bereich wechseln" (und Weiterleitungs-Antworten wie Kartuschen
      // „Noch keinen"): Eine Weiche – mehrere Kacheln – zeigt ihre Auswahl
      // selbst. Ein einfacher Teaser (z. B. auf einer Collection) holt die
      // Uebersichtsseite mit der Weiche in seinen Container, statt die Seite
      // zu verlassen. Gezaehlt werden nur die EIGENEN Startpunkte – eine
      // eingehaengte Weiche bringt weitere [data-start] mit.
      this.addEventListener('alb:berater-uebersicht', function (ev) {
        if (self._eigeneStarts().length < 2) {
          var url = ev.detail && ev.detail.url;
          if (!url) return;
          ev.preventDefault();
          ev.stopPropagation();
          self._zeigeUebersicht(url);
          return;
        }
        ev.preventDefault();
        ev.stopPropagation();
        self._zurueckZumTeaser();
      });

      this._wiederherstellen(knoepfe);
      this._vorladenEinrichten(knoepfe);
    }

    /* ---------- Vorladen ----------
       Der Berater (HTML ~100–400 kB + Skript) wird geholt, BEVOR geklickt wird –
       der Klick zeigt ihn dann ohne Wartezeit. Einfacher Teaser (ein Ziel):
       sobald er in die Naehe des Sichtbereichs kommt, im Leerlauf. Weiche
       (mehrere Kacheln): erst bei Hover/Fokus/Antippen der jeweiligen Kachel,
       damit nicht alle Berater auf Verdacht geladen werden. */
    _vorladenEinrichten(knoepfe) {
      var self = this;
      this._vorab = {};
      for (var i = 0; i < knoepfe.length; i++) {
        (function (knopf) {
          var los = function () { self._vorladen(knopf); };
          knopf.addEventListener('pointerenter', los, { once: true });
          knopf.addEventListener('focusin', los, { once: true });
          knopf.addEventListener('touchstart', los, { once: true, passive: true });
        })(knoepfe[i]);
      }
      if (knoepfe.length !== 1 || !('IntersectionObserver' in window)) return;
      var beobachter = new IntersectionObserver(function (eintraege) {
        if (!eintraege.some(function (e) { return e.isIntersecting; })) return;
        beobachter.disconnect();
        var leerlauf = window.requestIdleCallback || function (fn) { return window.setTimeout(fn, 300); };
        leerlauf(function () { self._vorladen(knoepfe[0]); });
      }, { rootMargin: '600px 0px' });
      beobachter.observe(this);
    }

    _vorladen(knopf) {
      var ziel = (knopf && knopf.getAttribute('data-ziel')) || this.getAttribute('data-ziel');
      if (!ziel || this._vorab[ziel]) return;
      var key = (knopf && knopf.getAttribute('data-key')) || this.getAttribute('data-key');
      var self = this;
      this._vorab[ziel] = this._holeHtml(ziel, key).catch(function (e) {
        delete self._vorab[ziel];   // beim Klick erneut versuchen
        throw e;
      });
      this._vorab[ziel].catch(function () { /* still – Klick versucht es erneut */ });
      ladeSkript(this.getAttribute('data-skript')).catch(function () { /* still */ });
    }

    /* Ruecksprung (z. B. von der Produktseite ueber „Details ansehen"): Steht
       ein Ergebnis im Hash, den passenden Berater gleich wieder einhaengen –
       er liest den Hash selbst und zeigt sein Ergebnis. Der Bereich im Hash
       ist das Seiten-Handle des Beraters (/pages/<handle>). */
    _wiederherstellen(knoepfe) {
      var hash = window.location.hash || '';
      if (!/(?:^|#|&)berater=/.test(hash)) return;
      var m = /(?:^|#|&)bereich=([^&]+)/.exec(hash);
      if (!m) return;
      var bereich = decodeURIComponent(m[1]);
      for (var i = 0; i < knoepfe.length; i++) {
        var ziel = knoepfe[i].getAttribute('data-ziel') || this.getAttribute('data-ziel') || '';
        var pfad = ziel.split('?')[0].split('#')[0].replace(/\/+$/, '');
        if (pfad.slice(-('/pages/' + bereich).length) === '/pages/' + bereich) {
          // Nach dem Laden zum Ergebnis springen: Die Seite wird beim
          // Zuruecknavigieren neu geladen und steht sonst ganz oben – der
          // Browser kennt die alte Position nicht, weil der Berater erst
          // nachgeladen wird.
          this._zumErgebnis = true;
          this._starten(knoepfe[i]);
          return;
        }
      }
      // Bereich wurde im Container gewechselt („Bereich wechseln"): Dann gehoert
      // das Ergebnis zu einem Berater, den dieser Teaser nicht selbst anbietet.
      // Die zuletzt geladene Weiche erneut einhaengen – sie stellt den
      // gewaehlten Berater aus dem Hash selbst wieder her.
      if (this._eigeneStarts().length < 2) {
        var weiche = null;
        try { weiche = sessionStorage.getItem('alb:berater-weiche:' + window.location.pathname); } catch (e) { /* privat */ }
        if (weiche) this._zeigeUebersicht(weiche, true);
      }
    }

    _eigeneStarts() {
      var self = this;
      return Array.prototype.filter.call(this.querySelectorAll('[data-start]'), function (el) {
        return el.closest('alb-berater-teaser') === self;
      });
    }

    /* Bereichs-Auswahl im selben Container: Die Uebersichtsseite (Weiche)
       wird wie ein Berater nachgeladen; ihre Kacheln laden den gewaehlten
       Fachberater dann in IHREN Container. Den Ergebnis-Hash hat der Berater
       schon geleert – sonst oeffnete die Weiche beim Einhaengen sofort wieder
       denselben Bereich. Scheitert das Laden, fuehrt _scheitern auf die Seite. */
    _zeigeUebersicht(url, wiederherstellen) {
      if (this._laeuft) return;
      try { sessionStorage.setItem('alb:berater-weiche:' + window.location.pathname, url); } catch (e) { /* privat */ }
      this._laeuft = true;
      this.setAttribute('data-laedt', '');
      this._zielUrl = url;
      this._zielKey = null;
      var self = this;
      this._holeHtml(url, null)
        .then(function (html) { return self._haengeEin(html); })
        .then(function () {
          // Beim Wiederherstellen scrollt die eingehaengte Weiche selbst zum Ergebnis.
          if (wiederherstellen) return;
          if (typeof self.scrollIntoView === 'function') {
            var reduziert = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            self.scrollIntoView({ block: 'start', behavior: reduziert ? 'auto' : 'smooth' });
          }
        })
        .catch(function () { self._scheitern(); });
    }

    /* Blendet den Teaser wieder ein. Der geladene Berater bleibt im DOM –
       beim naechsten Klick ist er sofort da, ohne zweiten Netzwerkweg. */
    _zurueckZumTeaser() {
      var host = this.querySelector('[data-ziel-host]');
      var teaser = this.querySelector('[data-teaser]');
      if (host) host.hidden = true;
      if (teaser) teaser.hidden = false;
      // Ergebnis-Hash loeschen: Sonst stellte ein Reload den Berater wieder her,
      // obwohl der Besucher zur Auswahl zurueckgekehrt ist.
      if (/(?:^|#|&)berater=/.test(window.location.hash || '') && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      var gewaehlt = this.querySelector('[data-start][data-gewaehlt]');
      if (gewaehlt) gewaehlt.removeAttribute('data-gewaehlt');
      if (typeof this.scrollIntoView === 'function') {
        var reduziert = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollIntoView({ block: 'start', behavior: reduziert ? 'auto' : 'smooth' });
      }
    }

    _starten(knopf) {
      // Ziel vom geklickten Element, sonst vom Host (einfacher Teaser).
      var ziel = (knopf && knopf.getAttribute('data-ziel')) || this.getAttribute('data-ziel');

      // Schon geladen und dasselbe Ziel? Dann nur wieder einblenden – das ist
      // der Weg zurueck nach „Beratung neu starten". Bei der Weiche kann ein
      // anderer Bereich gewaehlt sein; dann wird normal nachgeladen.
      var host = this.querySelector('[data-ziel-host]');
      var app = host && host.querySelector('alb-produktberater');
      if (app && ziel === this._zielUrl) {
        var teaserBox = this.querySelector('[data-teaser]');
        if (teaserBox) teaserBox.hidden = true;
        host.hidden = false;
        if (knopf) knopf.setAttribute('data-gewaehlt', '');
        if (typeof app.starte === 'function') app.starte();
        return;
      }

      if (this._laeuft) return;
      this._laeuft = true;
      this.setAttribute('data-laedt', '');
      if (knopf) knopf.setAttribute('data-gewaehlt', '');

      this._zielUrl = ziel;
      this._zielKey = (knopf && knopf.getAttribute('data-key')) || this.getAttribute('data-key');

      var self = this;
      var html = (this._vorab && this._vorab[ziel]) || this._holeHtml(ziel, this._zielKey);
      html
        .then(function (html) { return self._haengeEin(html); })
        .catch(function () { self._scheitern(); });
    }

    /* ---------- Beschaffung ---------- */

    _holeHtml(url, zielKey) {
      url = url || this._zielUrl || this.getAttribute('data-ziel');
      if (!url) return Promise.reject(new Error('kein Ziel'));

      var key = this._gemerkteKennung(url) || zielKey || this.getAttribute('data-key');
      // Die Section Rendering API kennt nur die lange Form
      // template--<id>__<schluessel>; der kurze Schluessel aus dem Editor
      // liefert immer null. Dann gleich die ganze Seite holen, statt erst
      // einen sicher scheiternden Request abzuwarten.
      if (!key || key.indexOf('__') === -1) return this._holeGanzeSeite(url);

      var self = this;
      var mitKey = url + (url.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(key);

      // Bewusst OHNE "Accept: application/json": Damit beantwortet Shopify
      // /pages/<handle> mit dem Seiten-Datensatz statt mit der Section, und die
      // Section Rendering API kaeme nie zum Zug.
      return fetch(mitKey)
        .then(function (r) {
          if (!r.ok) throw new Error('API');
          return r.json();
        })
        .then(function (daten) {
          var html = daten ? daten[key] : null;
          // Unbekannte Kennung beantwortet Shopify mit null, nicht mit 404.
          if (typeof html !== 'string' || !html) throw new Error('Kennung');
          return html;
        })
        .catch(function () { return self._holeGanzeSeite(url); });
    }

    /* Fallback: ganze Seite laden und den Berater herausschneiden. Kostet
       deutlich mehr Bytes, rettet aber eine falsch eingetragene Kennung. */
    _holeGanzeSeite(url) {
      var self = this;
      return fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('Seite');
          return r.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          // Ziel ist entweder ein Fachberater oder die Bereichs-Weiche: Auch sie
          // ist ein Einstieg – sie holt den gewaehlten Fachberater ihrerseits nach.
          var app = doc.querySelector('alb-produktberater') || doc.querySelector('alb-berater-teaser');
          if (!app) throw new Error('kein Berater auf der Zielseite');
          // Den Section-Wrapper mitnehmen: Er traegt die id, auf die sich das
          // mitgelieferte CSS bezieht (#section-…).
          var sek = app.closest('.shopify-section') || app.closest('section') || app;
          self._merkeKennung(url, sek.id);
          return sek.outerHTML;
        });
    }

    /* ---------- Section-Kennung ---------- */

    /* In JSON-Templates heisst eine Section zur Laufzeit template--<id>__<schluessel>,
       im Theme-Editor steht aber nur der Schluessel. Die Section Rendering API
       kennt nur die lange Form. Der erste Ladevorgang liest sie aus der Zielseite
       und legt sie fuer die Sitzung ab – ab dann reichen rund 10 statt 400 kB.
       Stimmt eine gemerkte Kennung nicht mehr, faellt der Weg von allein wieder
       auf die ganze Seite zurueck und merkt sich die neue. */
    _kennungsSchluessel(url) { return 'alb:berater-sektion:' + url; }

    _gemerkteKennung(url) {
      try { return sessionStorage.getItem(this._kennungsSchluessel(url)); }
      catch (e) { return null; }
    }

    _merkeKennung(url, id) {
      var praefix = 'shopify-section-';
      if (!id || id.indexOf(praefix) !== 0) return;
      try { sessionStorage.setItem(this._kennungsSchluessel(url), id.slice(praefix.length)); }
      catch (e) { /* privater Modus: dann eben jedes Mal die ganze Seite */ }
    }

    /* ---------- Einhaengen ---------- */

    _haengeEin(html) {
      var host = this.querySelector('[data-ziel-host]');
      var teaser = this.querySelector('[data-teaser]');
      if (!host) throw new Error('kein Ziel-Container');

      host.innerHTML = html;
      host.hidden = false;
      if (teaser) teaser.hidden = true;
      this.removeAttribute('data-laedt');
      // Wichtig fuer die Weiche: Dort fuehrt jede Kachel zu einem anderen Ziel.
      // Bliebe die Sperre stehen, liesse sich nach dem ersten Bereich kein
      // zweiter mehr laden.
      this._laeuft = false;

      var self = this;
      return ladeSkript(this.getAttribute('data-skript'))
        .then(function () { return customElements.whenDefined('alb-produktberater'); })
        .then(function () {
          // Eingehaengt sein kann auch die Bereichs-Weiche. Sie bringt ihre
          // eigenen Kacheln mit und laedt den Fachberater erst beim Klick nach –
          // dann gibt es hier noch keinen <alb-produktberater>.
          var app = host.querySelector('alb-produktberater');
          if (app) {
            // Zeigt der Berater wegen eines geteilten Ergebnis-Links bereits ein
            // Ergebnis, nicht ins Quiz zwingen.
            var zeigtErgebnis = app.querySelector('[data-screen="ergebnis"]:not([hidden])');
            if (!zeigtErgebnis && typeof app.starte === 'function') app.starte();
          }
          self.dispatchEvent(new CustomEvent('alb:berater-geladen', { bubbles: true }));
          if (self._zumErgebnis && app) {
            self._zumErgebnis = false;
            var ziel = app.querySelector('[data-anker]') || app;
            // Kurz warten, bis die Ergebniskarten Hoehe haben. setTimeout statt
            // requestAnimationFrame: rAF ruht in Hintergrund-Tabs (Zurueck in
            // einem nicht sichtbaren Tab).
            setTimeout(function () {
              if (typeof ziel.scrollIntoView === 'function') ziel.scrollIntoView({ block: 'start', behavior: 'auto' });
            }, 80);
          }
        });
    }

    /* ---------- Fehlerfall ---------- */

    _scheitern() {
      this.removeAttribute('data-laedt');
      this._laeuft = false;

      var ziel = this._zielUrl || this.getAttribute('data-ziel');
      var text = this.getAttribute('data-fehler-text');
      var box = this.querySelector('.alb-bt-cta') || this.querySelector('[data-fehler-host]');

      if (box && text && !box.querySelector('[data-fehler]')) {
        var p = document.createElement('p');
        p.className = 'alb-bt-hinweis';
        p.setAttribute('data-fehler', '');
        p.setAttribute('role', 'status');
        p.textContent = text;
        box.appendChild(p);
      }

      // Kein Sackgassen-Fallback: Die Ratgeber-Seite kann alles, was der
      // Teaser nachladen wollte. Der Hinweis bleibt nur stehen, falls auch
      // die Navigation scheitert.
      if (ziel) window.location.href = ziel;
    }
  }

  customElements.define('alb-berater-teaser', AlbBeraterTeaser);
})();
